<button mat-icon-button *ngFor="let option of toggleOptions let i = index;"
    class="toggle-icon-button-option"
    [id]="option.buttonId"
    [attr.aria-label]="option.buttonText"
    [matTooltip]="option.buttonText | capitalize"
    [ngClass]="{'is-active-button': selectedOption === option.buttonValue}"
    (click)="onToggle(option.buttonValue)">
    <mat-icon>{{option.buttonIcon}}</mat-icon>
</button>
